$(document).ready(function() {
    //inject social share
    var socialMob = $('#share-bar__social-mob').text();
    var skin = $('.header_skin_life').length ? 'life' : 'main';

    /* Set class name and skin specific class name */
    var className = 'stickyNav stickyNav_skin_' + skin;

    //build the element
    var navContainer = document.createElement('div');
    navContainer.className = className;

    var hamburgerNav = document.createElement('a');
    hamburgerNav.className = 'hamburger-nav icon-Nav_Hamburger';
    hamburgerNav.href = '#';
    $(hamburgerNav).click(function(e) {
        e.preventDefault();
        $('.hamburger-open-button')[0].click();
    });
    navContainer.appendChild(hamburgerNav);

    var hLogoContainer = document.createElement('a');
    hLogoContainer.className = 'hLogoContainer icon-Social-HuffPost';
    hLogoContainer.href = location.protocol + '//' + location.host;
    hLogoContainer.title = $('meta[property="og:site_name"]').attr("content");
    navContainer.appendChild(hLogoContainer);

    //title placeholder
    var titlePlaceholder = document.createElement('div');
    titlePlaceholder.className = 'titlePlaceholder top-nav-sticky__title';
    $(titlePlaceholder).text($('.headline__title').text());
    navContainer.appendChild(titlePlaceholder);
    var canScroll = true;
    var articleContainer = $('.entry__content');
    var bottomArticle = articleContainer.position().top + articleContainer.offset().top + articleContainer.outerHeight(true);

    if (!$('.stickyNav').length) {
        $('body').prepend(navContainer);
    }

    $(window).bind("scroll", function() {
        var stickyNavOn = ($(window).scrollTop() > 400);
        var stickyNavOff = ($(window).scrollTop() > bottomArticle);

        if (stickyNavOn) {
            $(document).trigger("stickyNav:on");
        } else {
            $(document).trigger("stickyNav:off");
        }

        if (stickyNavOff && canScroll) {
            canScroll = false;
        }

        if ($(window).scrollTop() < bottomArticle && !canScroll) {
            canScroll = true;
        }
    });

    /* sticky bottom social-share, mobile-only */
    var $body = $('body');
    if(skin == 'main' && !$body.hasClass('mapi')) {
        //build the element
        var bottomSocialShareBar = document.createElement('div');
        bottomSocialShareBar.className = 'shareBarBottom mobile-only yr-share-bottom';

        //social buttons
        var socialButtons2;
        var socialButtonsContainer2 = document.createElement('div');
        socialButtonsContainer2.className = 'share-container-lower';

        socialButtons2 = '<div class="share-bar">'+ socialMob +'</div>';
        $(socialButtonsContainer2).html(socialButtons2);

        bottomSocialShareBar.appendChild(socialButtonsContainer2);

        //plus button
        var plusButton = document.createElement('div');
        plusButton.className = 'expand-social-button';
        $(plusButton).html('<i class="fa fa-plus"/>');
        bottomSocialShareBar.appendChild(plusButton);

        if($(bottomSocialShareBar).find('li').length > 10) {
            $(bottomSocialShareBar).addClass('large');
        }

        $(plusButton).bind('click', function(){
            console.log('plus button clicked');
            $('.shareBarBottom').toggleClass('share-bar-expanded');

            if($('.shareBarBottom').hasClass('share-bar-expanded')) {
                $(plusButton).html('<i class="fa fa-minus"/>');
            } else {
                $(plusButton).html('<i class="fa fa-plus"/>');
            }
        });

        $body.prepend(bottomSocialShareBar);

        if (navigator.userAgent.toLowerCase().match(/iphone|ipad/)) {
            $('.share-bar__item.sms a').each(function() {
                var $this = $(this);
                var url = $this.attr('href').replace(/\?/, '&');
                $this.attr('href', url);
            });
        }
    }
});
